<svg
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect opacity="0.2" x="3" y="3" width="14" height="14" fill="currentColor" />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M2 4L2 16C2 17.1046 2.89543 18 4 18L16 18C17.1046 18 18 17.1046 18 16V4C18 2.89543 17.1046 2 16 2L4 2C2.89543 2 2 2.89543 2 4ZM16 4H4V16H16V4Z"
    fill="currentColor"
  />
  <path
    d="M10.1241 12.2793L10.1252 12.2804L8.94672 13.4589L4.99978 9.51192L6.17829 8.33341L8.94562 11.1007L14.213 5.83335L15.3915 7.01186L10.1241 12.2793Z"
    fill="currentColor"
  />
</svg>
